import React from "react";
import "../css/ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="eb-container">
          <div className="eb-card">
            <div className="eb-icon">⚖️</div>
            <h2 className="eb-title">Something went wrong</h2>
            <p className="eb-text">
              We encountered an unexpected error while loading this section. Our
              system has safely prevented any data loss.
            </p>
            <div className="eb-actions">
              <button
                className="eb-btn eb-btn--primary"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </button>
              <button
                className="eb-btn eb-btn--ghost"
                onClick={this.handleReset}
              >
                Go to Homepage
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
